export default __webpack_public_path__ + "static/media/TruNatomy-Grafik.0a7d44a9.png";